import actionType from "../constants/index";

const initialState = {
    modalUpdateState: false,
};

export const updateReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.CHANGE_UPDATE_MODAL_STATE:
            return {
                ...state,
                modalUpdateState: action.payload,
            };
        default:
            return state;
    }
};
